import app from 'flarum/forum/app';
import { contextParams } from './context';

/**
 * Loads the saved draft for a context. Resolves to null when there is none.
 */
export function loadDraft(context) {
  return app
    .request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/draft-post/drafts',
      params: contextParams(context),
    })
    .then((response) => {
      const record = response && response.data && response.data[0];

      if (!record) return null;

      return {
        title: record.attributes.title || '',
        content: record.attributes.content || '',
      };
    });
}

export function saveDraft(context, title, content) {
  return app.request({
    method: 'POST',
    url: app.forum.attribute('apiUrl') + '/draft-post/drafts',
    body: {
      data: {
        attributes: {
          type: context.type,
          discussionId: context.discussionId,
          postId: context.postId,
          title: title,
          content: content,
        },
      },
    },
  });
}

export function deleteDraft(context) {
  return app.request({
    method: 'DELETE',
    url: app.forum.attribute('apiUrl') + '/draft-post/drafts',
    params: contextParams(context),
  });
}
